/** Build metadata injected by Vite at bundle time. */
export const BUILD_HASH_SHORT = __COMMIT_HASH__.slice(0, 6);
